<template>
    <b-modal ref="mdlRegistraUscitaEntrata" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="xl" @shown="onShow" scrollable>
        <!-- SCHEDA DEL PAZIENTE DA IMPLEMENTARE CON PRESENZA DA COMPLETARE -->
        <b-row>
            <b-col cols="12">
                <div class="alert alert-info">
                    <strong>{{ pazienteInfo.nome }} {{ pazienteInfo.cognome }}</strong
                    ><br />
                    <p>Codice Fiscale: {{ pazienteInfo.identificativo }}</p>

                    <div v-if="uscitaDaCompletare && tipoOperazione === 'ENTRATA'" class="mt-3">
                        <!-- <p><span class="sa-label-data">Uscita da completare:</span> {{ formatDateTime(uscitaDaCompletare.dataOraUscita) }}</p>
                        <p><span class="sa-label-data">Motivo:</span> {{ uscitaDaCompletare.motivo || "Nessun motivo" }}</p> -->
                        <p><strong>Uscita da completare:</strong> {{ formatDateTime(uscitaDaCompletare.dataOraUscita) }}</p>
                        <p><strong>Motivo: </strong> {{ uscitaDaCompletare.motivo || "Nessun motivo" }}</p>
                        <p><strong>Note Uscita Programmata: </strong> {{ uscitaDaCompletare.noteUscitaProgrammata || "Nessuna nota" }}</p>
                        <p><strong>Note Uscita: </strong> {{ uscitaDaCompletare.noteUscita || "Nessuna nota" }}</p>
                    </div>

                    <div v-if="uscitaSelezionata" class="mt-3">
                        <strong>Uscita programmata selezionata: {{ formatDateTime(uscitaSelezionata.dataOraUscitaProgrammata) }} </strong>
                        <p><strong>Motivo:</strong> {{ uscitaSelezionata.motivo || "Nessun motivo" }}</p>
                        <!-- SEZIONE TOLTA PERCHE' LE NOTE SONO GIA VISIBILI NELLA LISTA DELLE USCITE PROGRAMMATE -->
                        <!-- <p><strong>Note Programmate:</strong> {{ uscitaSelezionata.noteUscitaProgrammata || "Nessuna nota" }}</p> -->
                    </div>
                </div>
            </b-col>
        </b-row>
        <!-- La variabile tipoOperazione è FONDAMENTALE per poter gestirmi il DOM in modo dinamico. 
             tipoOperazione glielo passo dal metodo del componente (RsaGestioneOspitiListComponent) che richiama questa modale attraverso il metodo  onClickPresenzaUscita/Entrate con i relativi parametri che questo componente erediterà come l'item del paziente che mi servirà in un secondo momento per fare la getLista delle presenze attraverso il suo ID.
             Questo avviene nel metodo show -->
        <b-row>
            <b-col cols="12" sm="6">
                <!-- Operatore ternario che cambia il nome dell'input in base al tipo operazione -->
                <span class="sa-form-label">{{ tipoOperazione === "ENTRATA" ? "Data/Ora Entrata" : "Data/Ora Uscita" }}</span>
                <!-- Operatore ternario che cambia il v-model in base al tipo di operazione, importante mettere l'attributo ':' prima del v-model per renderlo dinamico -->
                <date-picker format="DD/MM/YYYY HH:mm" value-type="timestamp" v-model="currentDateTime" type="datetime"></date-picker>
            </b-col>

            <b-col cols="12" sm="6">
                <span class="sa-form-label">Motivo</span>
                <!-- il b-form non è disabilitato unicamente se è un uscita di emergenza, il paziente deve rientrare imposto isUscitaUrgenza a true, se seleziono un uscita programmata lo imposto sempre a true -->
                <b-form-select v-model="jsonDataPresenza.motivo" :options="motivoOptions" value-field="voce" text-field="voce" :disabled="!isUscitaUrgenza">
                    <template #first>
                        <b-form-select-option :value="null"> - Seleziona motivo - </b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>

            <!--  <small class="text-info"> Debug: isUscitaUrgenza={{ isUscitaUrgenza }}, tipoOperazione={{ tipoOperazione }}, uscitaSelezionata={{ !!uscitaSelezionata }} </small> -->

            <b-col cols="12">
                <span class="sa-form-label">Note</span>
                <b-form-textarea v-model="noteCorrente" rows="7" max-rows="10" placeholder="Note aggiuntive (opzionale)..."></b-form-textarea>
            </b-col>
        </b-row>
        <br />
        <div v-if="tipoOperazione === 'USCITA'">
            <b-row>
                <b-col cols="12">
                    <h5 class="mb-3">Seleziona l'uscita programmata da registrare</h5>
                </b-col>
            </b-row>
            <rsa-scheda-ospite-uscite-list-component v-if="tipoOperazione === 'USCITA'" ref="cmpRsaSchedaOspiteUsciteList" :modalMode="true" @onSelectUscitaProgrammata="onSelectUscitaProgrammata" :tipoOperazione="tipoOperazione" />
            <rsa-scheda-ospite-uscite-list-component v-else ref="cmpRsaSchedaOspiteUsciteListEntrata" :modalMode="true" :tipoOperazione="tipoOperazione" />
            <!-- Alert uscita selezionata -->
            <!-- <div v-if="uscitaSelezionata" class="mt-3">
                <div class="alert alert-success">
                    <strong>Uscita programmata selezionata: {{ formatDateTime(uscitaSelezionata.dataOraUscitaProgrammata) }} </strong><br />
                    <p>Motivo: {{ uscitaSelezionata.motivo || "Nessun motivo" }}</p>
                </div>
            </div> -->
        </div>
        <!-- Alert uscita urgenza -->
        <!-- <div v-if="isUscitaUrgenza" class="mt-3">
            <div class="alert alert-warning"><strong>Uscita d'Urgenza</strong> - Non programmata</div>
        </div> -->
        <!--  -->

        <!-- Alert uscita da completare (per ENTRATA) -->
        <!-- <div v-if="uscitaDaCompletare && tipoOperazione === 'ENTRATA'" class="mt-3">
            <div class="alert alert-info">
                <strong>Uscita da completare: {{ formatDateTime(uscitaDaCompletare.dataOraUscita) }} </strong><br />
                <p>Motivo: {{ uscitaDaCompletare.motivo || "Nessun motivo" }}</p>
            </div>
        </div> -->

        <template #modal-footer>
            <b-button size="md" variant="outline-danger" @click="onCloseModal">Annulla</b-button>
            <b-button v-if="tipoOperazione === 'USCITA' && !uscitaSelezionata && isUscitaUrgenza" size="md" variant="outline-warning" @click="onClickUscitaUrgenza">
                Uscita d'Urgenza
                <font-awesome-icon icon="exclamation-triangle" class="mr-2" />
            </b-button>
            <b-button v-else size="md" variant="outline-success" @click="onClickSalva" :disabled="!canSave">
                {{ getSaveButtonText() }}
            </b-button>
        </template>

        <!-- <rsa-scheda-ospite-uscite-list-component ref="cmpRsaSchedaOspiteUsciteList" /> -->

        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
import RsaSchedaOspiteUsciteListComponent from "./RsaSchedaOspiteUsciteListComponent.vue";

export default {
    name: "RsaRegistrazioneEntrateUsciteModalEditComponent",
    mixins: [UtilityMixin],
    components: { DatePicker, ModalError, RsaSchedaOspiteUsciteListComponent },

    data() {
        return {
            title: "",
            tipoOperazione: null, // 'ENTRATA' o 'USCITA'
            pathResource: "/rsapazientepresenze",
            pathResourceDizionario: "/rsadizionario",

            //Gestione USCITE
            usciteProgrammate: [],
            isUscitaUrgenza: false,
            uscitaSelezionata: null,

            //Gestione ENTRATE
            uscitaDaCompletare: null,

            pazienteInfo: {
                id: null,
                nome: "",
                cognome: "",
                identificativo: "",
            },
            jsonDataPresenza: {
                id: null,
                idAccettazione: null,
                dataOraUscitaProgrammata: null,
                dataOraUscita: null,
                dataOraEntrataProgrammata: null,
                dataOraEntrata: null,
                tipo: null,
                motivo: null,
                presenteNellaData: true,
                noteEntrata: null,
                noteUscita: null,
            },
            motivoOptions: [],
        };
    },
    computed: {
        canSave() {
            // Per ENTRATA: deve avere trovato un'uscita da completare
            if (this.tipoOperazione === "ENTRATA") {
                return this.uscitaDaCompletare;
            }

            // Per USCITA: deve aver selezionato un'uscita programmata O essere uscita urgenza
            if (this.tipoOperazione === "USCITA") {
                if (this.isUscitaUrgenza) {
                    // Per uscita urgenza: dataOraUscita E motivo sono obbligatori
                    return this.jsonDataPresenza.dataOraUscita && this.jsonDataPresenza.motivo && this.jsonDataPresenza.motivo.trim() !== "";
                }
                return this.uscitaSelezionata && this.jsonDataPresenza.dataOraUscita;
            }

            return false;
        },
        currentDateTime: {
            get() {
                // GET: viene chiamato quando Vue legge il valore
                let me = this;
                // console.log("GET del Computed per currentDateTime chiamato - tipoOperazione:", me.tipoOperazione);
                if (me.tipoOperazione === "ENTRATA") {
                    // Se dataOraEntrata esiste, la restituisco, altrimenti data corrente
                    return me.jsonDataPresenza.dataOraEntrata || new Date().getTime();
                } else {
                    //Stessa cosa
                    return me.jsonDataPresenza.dataOraUscita || new Date().getTime();
                }
            },
            set(value) {
                // SET: viene chiamato quando Vue scrive/modifica il valore
                let me = this;
                if (me.tipoOperazione === "ENTRATA") {
                    me.jsonDataPresenza.dataOraEntrata = value;
                } else {
                    me.jsonDataPresenza.dataOraUscita = value;
                }
            },
        },
        noteCorrente: {
            get() {
                let me = this;
                // console.log("GET del Computed per noteCorrente chiamato - tipoOperazione:", me.tipoOperazione);
                if (me.tipoOperazione === "ENTRATA") {
                    return me.jsonDataPresenza.noteEntrata || "";
                } else {
                    return me.jsonDataPresenza.noteUscita || "";
                }
            },
            set(value) {
                let me = this;
                // console.log("SET noteCorrente - tipoOperazione:", me.tipoOperazione, "value:", value);

                if (me.tipoOperazione === "ENTRATA") {
                    // console.log("SET noteEntrata con:", value);
                    me.jsonDataPresenza.noteEntrata = value;
                } else {
                    // console.log("SET noteUscita con:", value);
                    me.jsonDataPresenza.noteUscita = value;
                }
            },
        },
    },

    mounted() {
        let me = this;
        me.loadDizionarioData();
    },
    watch: {
        isUscitaUrgenza: function (newIsUscitaUrgenza) {
            if (newIsUscitaUrgenza) {
                // console.log("Modalità uscita d'urgenza attivata", this.isUscitaUrgenza);
            }
        },
    },
    methods: {
        // ==================== METODI PRINCIPALI ====================
        show(paziente, tipoOperazione) {
            let me = this;
            me.pazienteInfo = {
                id: paziente.id,
                nome: paziente.nome,
                cognome: paziente.cognome,
                identificativo: paziente.identificativo,
            };
            me.tipoOperazione = tipoOperazione;
            // console.log("show: Mostro il modal per:", tipoOperazione);
            me.title = tipoOperazione === "ENTRATA" ? "Registra Entrata" : "Registra Uscita";
            // Reset stato del modal
            me.uscitaSelezionata = null;
            me.isUscitaUrgenza = false;
            me.uscitaDaCompletare = null;
            me.jsonDataPresenza = {
                id: null,
                idAccettazione: paziente.id,
                dataOraUscitaProgrammata: null,
                dataOraUscita: tipoOperazione === "USCITA" ? new Date().getTime() : null,
                dataOraEntrataProgrammata: null,
                dataOraEntrata: tipoOperazione === "ENTRATA" ? new Date().getTime() : null,
                tipo: tipoOperazione,
                motivo: null,
                presenteNellaData: true,
                noteEntrata: null,
                noteUscita: null,
            };
            if (tipoOperazione === "USCITA") {
                me.isUscitaUrgenza = true;
            } else {
                me.isUscitaUrgenza = false;
            }
            me.loadDizionarioData();
            me.$refs.mdlRegistraUscitaEntrata.show();
        },
        onShow() {
            let me = this;
            // console.log("onShow: Modal aperto per:", me.tipoOperazione);
            // Carica i dati in base al tipo di operazione
            if (me.tipoOperazione === "USCITA") {
                // per le ucsite
                /* console.log("COMPONENTE IN ONSHOW: me.$refs.cmpRsaSchedaOspiteUsciteList", me.$refs.cmpRsaSchedaOspiteUsciteList); */
                me.$refs.cmpRsaSchedaOspiteUsciteList.setId(this.pazienteInfo.id);
                /* me.loadUsciteProgrammate(); */
            } else if (me.tipoOperazione === "ENTRATA") {
                // console.log("ENTRO IN ENTRATA NEL ONSHOW");

                me.loadDataUsciteDaCompletare();
            }
        },
        loadDizionarioData() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceDizionario, null, me.loadDizionarioDataSuccess, me.loadDizionarioDataError);
        },
        loadDizionarioDataSuccess(response) {
            let me = this;
            if (response.data?.data?.list) {
                me.motivoOptions = response.data.data.list.filter((item) => item.tipo === "MOTIVAZIONE_PRESENZE_USCITE");
            }
        },
        loadDizionarioDataError(error) {
            console.error("Errore nel caricamento delle motivazioni", error);
        },
        // ==================== UTILITY ====================
        getSaveButtonText() {
            if (this.tipoOperazione === "ENTRATA") {
                return "Registra Entrata";
            } else if (this.isUscitaUrgenza) {
                return "Registra Uscita d'Urgenza";
            } else {
                return "Registra Uscita";
            }
        },

        onCloseModal() {
            let me = this;
            me.$refs.mdlRegistraUscitaEntrata.hide();
            me.$emit("onClose");
        },
        // ==================== GESTIONE PRESENZE ====================

        loadDataUsciteDaCompletare() {
            let me = this;
            let filtroUscite = { idAccettazione: me.pazienteInfo.id, page: 1, forPage: 50 };
            UtilityMixin.methods.loadDataResources(me.pathResource, filtroUscite, me.loadDataUsciteDaCompletareSuccess, me.loadDataUsciteDaCompletareError);
        },
        loadDataUsciteDaCompletareSuccess(response) {
            let me = this;
            let presenze = response.data?.data?.list;
            let usciteDaCompletare = presenze.filter((presenza) => presenza.dataOraUscita && !presenza.dataOraEntrata);
            if (usciteDaCompletare.length > 0) {
                me.uscitaDaCompletare = usciteDaCompletare[0];
                // Precompila il form con i dati dell'uscita da completare
                me.jsonDataPresenza.id = me.uscitaDaCompletare.id;
                me.jsonDataPresenza.dataOraUscitaProgrammata = me.uscitaDaCompletare.dataOraUscitaProgrammata;
                me.jsonDataPresenza.dataOraUscita = me.uscitaDaCompletare.dataOraUscita;
                me.jsonDataPresenza.dataOraEntrataProgrammata = me.uscitaDaCompletare.dataOraEntrataProgrammata;
                me.jsonDataPresenza.motivo = me.uscitaDaCompletare.motivo;
                me.jsonDataPresenza.noteUscitaProgrammata = me.uscitaDaCompletare.noteUscitaProgrammata;
                me.jsonDataPresenza.noteUscita = me.uscitaDaCompletare.noteUscita;
                // console.log("Uscita da completare trovata:", me.uscitaDaCompletare);
            } else {
                // console.log("Nessuna uscita da completare trovata");
                me.uscitaDaCompletare = null;
            }
        },
        loadDataUsciteDaCompletareError(response) {
            let me = this;
            me.$refs.cmpModalError.show(response.data.data);
        },

        // async callUtilityMixin(pathResource, params) {
        //     return new Promise((resolve, reject) => {
        //         UtilityMixin.methods.loadDataResources(
        //             pathResource,
        //             params,
        //             (response) => resolve(response),
        //             (error) => reject(error)
        //         );
        //     });
        // },
        // async loadDataUsciteDaCompletare() {
        //     let me = this;
        //     try {
        //         let filtro = {
        //             idAccettazione: me.pazienteInfo.id,
        //             page: 1,
        //             forPage: 50,
        //         };
        //         // console.log("Caricamento uscite da completare per paziente:", me.pazienteInfo.id);
        //         const response = await me.callUtilityMixin(me.pathResource, filtro);
        //         let presenze = response.data?.data?.list;
        //         // console.log("metodo async, risposta del list nella varibaile presenze: ", presenze);

        //         // Trova uscite effettuate ma senza entrata
        //         let usciteDaCompletare = presenze.filter((presenza) => presenza.dataOraUscita && !presenza.dataOraEntrata);
        //         // console.log("presenze filtrato nella variabile usciteDaCOMPLETARE: ", usciteDaCompletare);

        //         if (usciteDaCompletare.length > 0) {
        //             me.uscitaDaCompletare = usciteDaCompletare[0];
        //             // Precompila il form con i dati dell'uscita da completare
        //             me.jsonDataPresenza.id = me.uscitaDaCompletare.id;
        //             me.jsonDataPresenza.dataOraUscitaProgrammata = me.uscitaDaCompletare.dataOraUscitaProgrammata;
        //             me.jsonDataPresenza.dataOraUscita = me.uscitaDaCompletare.dataOraUscita;
        //             me.jsonDataPresenza.dataOraEntrataProgrammata = me.uscitaDaCompletare.dataOraEntrataProgrammata;
        //             me.jsonDataPresenza.motivo = me.uscitaDaCompletare.motivo;
        //             me.jsonDataPresenza.noteUscitaProgrammata = me.uscitaDaCompletare.noteUscitaProgrammata;
        //             me.jsonDataPresenza.noteUscita = me.uscitaDaCompletare.noteUscita;
        //             // console.log("Uscita da completare trovata:", me.uscitaDaCompletare);
        //         } else {
        //             // console.log("Nessuna uscita da completare trovata");
        //             me.uscitaDaCompletare = null;
        //         }
        //     } catch (response) {
        //         console.error("Errore nel caricamento delle uscite da completare:", response);
        //         me.$refs.cmpModalError.show(response.data.data);
        //     }
        // },
        /* async loadUsciteProgrammate() {
            let me = this;
            try {
                let filtro = { idAccettazione: me.pazienteInfo.id, page: 1, forPage: 50 };
                console.log("Caricamento uscite programmate per paziente:", me.pazienteInfo.id);
                // AWAIT: aspetta che la chiamata si completi
                const response = await me.callUtilityMixin(me.pathResource, filtro);
                console.log("Risposta ricevuta:", response.data);

                let presenze = response.data?.data?.list || [];

                me.usciteProgrammate = presenze.filter((presenza) => presenza.dataOraUscitaProgrammata && !presenza.dataOraUscita);
                console.log("Uscite programmate trovate:", me.usciteProgrammate);
                console.log("Numero uscite programmate trovate:", me.usciteProgrammate.length);
            } catch (response) {
                console.error("Errore nel caricamento delle uscite programmate:", response);
                me.$refs.cmpModalError.show(response.data.data);
            }
        }, */
        // ==================== GESTIONE SELEZIONE ====================
        onSelectUscitaProgrammata(uscitaProgrammata) {
            let me = this;
            // console.log("Uscita programmata selezionata:", uscitaProgrammata);
            me.isUscitaUrgenza = false;
            me.uscitaSelezionata = uscitaProgrammata;
            // console.log("Campo motivo DISABILITATO (isUscitaUrgenza = false)");
            //Popolo campi del form
            me.jsonDataPresenza.id = uscitaProgrammata.id;
            me.jsonDataPresenza.dataOraUscitaProgrammata = uscitaProgrammata.dataOraUscitaProgrammata;
            me.jsonDataPresenza.dataOraEntrataProgrammata = uscitaProgrammata.dataOraEntrataProgrammata;
            me.jsonDataPresenza.motivo = uscitaProgrammata.motivo;
            me.jsonDataPresenza.noteUscitaProgrammata = uscitaProgrammata.noteUscitaProgrammata;
            me.jsonDataPresenza.presenteNellaData = uscitaProgrammata.presenteNellaData;
        },
        // ==================== GESTIONE SALVATAGGIO ====================
        onClickUscitaUrgenza() {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Stai per registrare un'uscita d'urgenza non programmata. Vuoi continuare?", {
                    title: "Conferma Uscita d'Urgenza",
                    size: "md",
                    okVariant: "outline-warning",
                    okTitle: "Sì, continua",
                    cancelTitle: "Annulla",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.isUscitaUrgenza = true;
                        me.uscitaSelezionata = null;
                        me.jsonDataPresenza.id = null;
                        me.jsonDataPresenza.idAccettazione = me.pazienteInfo.id;
                        me.jsonDataPresenza.dataOraUscitaProgrammata = null;
                        me.jsonDataPresenza.dataOraEntrataProgrammata = null;

                        if (!me.jsonDataPresenza.dataOraUscita) {
                            me.jsonDataPresenza.dataOraUscita = new Date().getTime();
                        }
                        me.jsonDataPresenza.tipo = "USCITA";
                        me.jsonDataPresenza.presenteNellaData = false;
                        me.onClickSalva();
                    }
                });
        },

        onClickSalva() {
            let me = this;
            // console.log("Dati da salvare:", me.jsonDataPresenza);
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonDataPresenza, me.saveSuccessResponse, me.saveErrorResponse);
        },

        saveSuccessResponse(response) {
            let me = this;
            me.$emit("onSave", response, me.tipoOperazione);
            me.$refs.mdlRegistraUscitaEntrata.hide();
            me.$bvToast.toast(`${me.tipoOperazione} registrata con successo`, {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        saveErrorResponse(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
    },
};
</script>
<style scoped>
.bold-label {
    font-weight: bold;
}
</style>
